import { useRouteMatch } from 'react-router';
/**
 * Returns params from route match
 */
var useRouteMatchParams = function (url) {
    var match = useRouteMatch(url);
    return (match === null || match === void 0 ? void 0 : match.params) || null;
};
export default useRouteMatchParams;
